import {mask} from 'vue-the-mask';
import vSelect from 'vue-select'

export default {
    components: {
        vSelect,
    },
    props: {
        min_amount: null,
        description: '',
    },
    directives: {mask},
    data: function () {
        return {
            //Loading states
            isRequestProcessing: false,
            isApplePayAvailable: false,

            card: {
                number: '',
                month: '',
                year: '',
                cvv: '',
            },

            certificate: {
                first_name: '',
                last_name: '',
                email: '',
                amount: null,
                message: '',
            },

            //Payment data
            paymentData: {
                dataValue: null,
                dataDescriptor: null,
            },

            payment_type: 'credit_card',
        }
    },
    computed: {
        loading: function () {
            return this.isRequestProcessing;
        },
        isExpressCheckoutAvailable: function () {
            return this.isApplePayAvailable;
        },
        //Payment types
        isPaymentTypeCreditCard: function () {
            return this.payment_type === PAYMENT_TYPE_CREDIT_CARD || !this.payment_type;
        },
        expressCheckoutClasses: function () {
            if (this.isExpressCheckoutAvailable) {
                return [];
            }

            return ['d-none'];
        },
    },
    created: function () {
    },
    methods: {
        onBuyCertificate: function () {
            this.sendCardPaymentRequest()
        },
        //*******************CREDIT CARD PAYMENT PROCESSING*******************//
        sendCardPaymentRequest: function () {
            this.$nextTick(() => this.$validator
                .validate()
                .then(valid => {
                    if (!valid) {

                        const first_error = this.$validator.errors.items[0].field;

                        if (first_error) {
                            this.$scrollTo(`[name="${first_error}"]`);
                        }
                        return;
                    }

                    this.isRequestProcessing = true;
                    let cardData = {},
                        secureData = {};

                    cardData.cardNumber = '' + this.card.number.replace(/\s+/g, '');
                    cardData.month = '' + this.card.month.replace(/\s+/g, '');
                    cardData.year = '' + this.card.year.replace(/\s+/g, '');
                    cardData.cardCode = '' + this.card.cvv.replace(/\s+/g, '');
                    secureData.authData = window.authData;
                    secureData.cardData = cardData;


                    window.Accept.dispatchData(secureData, this.authorizeResponseHandler);
                }));
        },
        authorizeResponseHandler: function (response) {

            console.debug(response);
            if (response.messages.resultCode === 'Error') {
                let message = '';
                let i = 0;
                while (i < response.messages.message.length) {
                    message += response.messages.message[i].text + "\n";
                    i++;
                }

                this.$message.error(message || 'Could not process your payment. Please try again.');
                this.$scrollTo(`[name="card[number]"]`);
                if (message) {
                    this.errors.add({
                        field: 'card[number]',
                        msg: message
                    });
                }
                this.isRequestProcessing = false;
            } else {
                this.submitPayment(response.opaqueData.dataDescriptor, response.opaqueData.dataValue);
            }
        },
        submitPayment: function (dataDescriptor, dataValue) {
            this.isRequestProcessing = true;

            let form = {
                certificate: this.certificate,
                payment_data: {
                    dataDescriptor: dataDescriptor,
                    dataValue: dataValue,
                    paymentType: this.payment_type,
                },
            };

            axios.post('/api/v1/checkout/gift-certificates/process', form)
                .then((response) => {
                    if (response.data.status === 'success') {
                        if (response.data.redirect_url) {
                            window.location.href = response.data.redirect_url;
                        } else {
                            window.location.href = '/account/';
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: response.data.message,
                            duration: 10000
                        });
                    }

                })
                .catch((error) => {
                    this.$message.error('Could not place your purchase. Please try again later.');
                    console.error(error);
                })
                .then(() => {
                    this.isRequestProcessing = false;
                });
        },
        //*******************/CREDIT CARD PAYMENT PROCESSING******************//
        resetForm() {
            this.card = {
                number: '',
                holder_name: '',
                month: '',
                year: '',
                cvv: '',
            };
            this.$nextTick(() => this.$validator.reset());
        },
        isPaymentType: function (requestedType) {

            return this.payment_type === requestedType;
        }
    },
}
